export default function Input({ label, ...props }) {
  return (
    <label className="field">
      <div className="label">{label}</div>
      <input className="input" {...props} />
    </label>
  );
}